import { Button, Spinner } from "@fluentui/react-components";

// Matches ButtonSize from the Button component in fluentui.
declare type ButtonSize = "small" | "medium" | "large";

interface ButtonWithLoadingProps {
  isLoading: boolean;
  text: string;
  onClick: (event: unknown) => void;
  disabled?: boolean;
  width?: string;
  size?: ButtonSize;
}

export const ButtonWithLoading = ({
  isLoading,
  text,
  onClick,
  disabled,
  width,
  size,
}: ButtonWithLoadingProps) => {
  const buttonIcon = isLoading && !disabled ? <Spinner size="tiny" /> : null;

  return (
    <Button
      size={size}
      appearance="primary"
      onClick={onClick}
      disabled={disabled}
      disabledFocusable={isLoading}
      icon={buttonIcon}
      style={{ width: width }}
    >
      {text}
    </Button>
  );
};
